'use strict';

var speciesConstructor = require('../internals/species-constructor');

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var arrayFilter = require('../internals/array-methods')(2);

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var aTypedArrayConstructor = ArrayBufferViewCore.aTypedArrayConstructor; // `%TypedArray%.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-%typedarray%.prototype.filter

ArrayBufferViewCore.exportProto('filter', function filter(callbackfn
/* , thisArg */
) {
  var list = arrayFilter(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  var C = speciesConstructor(this, this.constructor);
  var index = 0;
  var length = list.length;
  var result = new (aTypedArrayConstructor(C))(length);

  while (length > index) {
    result[index] = list[index++];
  }

  return result;
});